module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['dof-tag', _vm.isActive ? 'dof-tag--active' : 'dof-tag--normal'],
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.onClick($event)
      }
    }
  }, [_c('p', {
    staticClass: " weex-el weex-text",
    class: ['dof-tag-text', _vm.isActive ? 'dof-tag-text--active' : 'dof-tag-text--normal'],
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._t("default", null, {})], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-57774ad5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57774ad5","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-tag/index.vue
// module id = 625
// module chunks = 0 1